// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.ToggleButton_dashboard__6uIAT {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.ToggleButton_dashboardContain__G3Iom {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_dashboardContain__G3Iom,
.ToggleButton_bodythemedark__mk1cl .ToggleButton_dashboard__6uIAT,
.ToggleButton_bodythemedark__mk1cl .ToggleButton_cont2__y79\\+w {
  background-Color: #0f1824;
}

.ToggleButton_top_header__Cqcd3 .ToggleButton_top_header_inner__Uy0t5 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.ToggleButton_cont2__y79\\+w {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.ToggleButton_subLink__qrmnO svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.ToggleButton_cst_vendr__TITQX input {
  min-height: 35px !important;
}

.ToggleButton_cst_vendr__TITQX .ToggleButton_form-control__klRMx {
  background-color: #f5f6fa;
  border: none;
}

.ToggleButton_footer__k\\+jkH {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.ToggleButton_bodythemelight__xbVdb {
  background-color: #fff;
  padding-top: 90px;
}

.ToggleButton_bodythemedark__mk1cl {
  background-color: #132337;
  padding-top: 90px;
}

.ToggleButton_bodythemeNew__Ui6IB {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.ToggleButton_headerthemelight__KBxNK {
  background-color: #fff;
}

.ToggleButton_headerthemedark__6P1qs {
  background-color: #132337;
}

.ToggleButton_top_header__Cqcd3 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.ToggleButton_menuthemelight__Um682 {
  background-color: #f5f6fa;
}

.ToggleButton_menuthemedark__VX9a7 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.ToggleButton_menulinklight__fo-41 span {
  color: #666666 !important;
}

.ToggleButton_menulinklight__fo-41 a {
  color: #CBCBCB !important;
}

.ToggleButton_menulinklight__fo-41:hover span,
.ToggleButton_menulinklight__fo-41:hover a {
  color: #fff !important;
}

.ToggleButton_menulinkdarkSelected__v5Q2p {
  background-color: #1c2e45;
  color: #3b82f6;
}

.ToggleButton_menuthemelight__Um682 .ToggleButton_menulinklightSelected__p-O0O {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.ToggleButton_menulinkdark__H9koF {
  color: #92afd3 !important;
}

.ToggleButton_menulinklight__fo-41:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.ToggleButton_menulinklight__fo-41 .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #CBCBCB !important;
}

.ToggleButton_menulinklight__fo-41:hover .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #fff !important;
}

.ToggleButton_menulinkdark__H9koF .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #92afd3 !important;
}

.ToggleButton_menulinkdark__H9koF:hover .ToggleButton_sub_arrow__3tNzG svg path {
  stroke: #fff !important;
}

.ToggleButton_menulinklight__fo-41:hover svg path,
.ToggleButton_menulinklightSelected__p-O0O svg path {
  fill: #fff !important;
}

.ToggleButton_menulinkdark__H9koF:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.ToggleButton_headinglight__46yE4 {
  color: #60677e;
}

.ToggleButton_headingdark__7Kdz4 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.ToggleButton_searchboxlight__IgyaT {
  background-color: #fff;
  border: none;
}

.ToggleButton_searchboxdark__s-55U {
  background-color: #132337;
  color: #fff;
  border: none;
}

.ToggleButton_searchboxdark__s-55U::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.ToggleButton_tableheadlight__HMlEb {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.ToggleButton_tableheadlight__HMlEb th {
  color: #fff;
}

thead .ToggleButton_tableheadlight__HMlEb th:first-child,
thead .ToggleButton_tableheaddark__CqMs1 th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .ToggleButton_tableheadlight__HMlEb th:last-child,
thead .ToggleButton_tableheaddark__CqMs1 th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.ToggleButton_table__gUUsS.ToggleButton_table-borderless__eH6QQ {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.ToggleButton_tableheaddark__CqMs1 {
  background-color: #132337;
  color: #fff;
}

.ToggleButton_table-borderless__eH6QQ tr:nth-child(even) {
  background-color: #F9FAFB;
}

.ToggleButton_table-borderless__eH6QQ .ToggleButton_left-section__meX0e {
  padding-top: 10px;
}

.ToggleButton_tablebodylight__CqriS td,
.ToggleButton_tablebodydark__9ZXJj td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.ToggleButton_tablebodylight__CqriS {
  background-color: #fff;
}
.ToggleButton_tablebodylight__CqriS:hover {
  background-color: #fff;
  cursor: auto;
}
.ToggleButton_tablebodylight__CqriS p {
  line-height: 24px;
}

.ToggleButton_tablebodydark__9ZXJj {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.ToggleButton_tablebodydark__9ZXJj:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.ToggleButton_paginationlight__BaJSK {
  color: #60677e !important;
  font-size: 13px !important;
}

.ToggleButton_paginationdark__fwOiV {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.ToggleButton_formthemelight__WUeV2 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.ToggleButton_formthemedark__CPoir {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.ToggleButton_formthemedark__CPoir ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.ToggleButton_viewformlight__kVJ4n {
  background-color: #f3f6f9;
}

.ToggleButton_permissionboxlight__gxJYP {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.ToggleButton_permissionboxdark__HAgO2 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.ToggleButton_errormsgclr__Lb-s- {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.ToggleButton_graphclrlight__CuUx3 {
  background-color: #fff;
}

.ToggleButton_graphclrdark__pHaGO {
  background-color: #132337;
}

/* 
Counter theme
*/
#ToggleButton_card1bglight__cN6YD {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card1bgdark__dKi5L {
  background: #392f28;
}

#ToggleButton_card2bglight__Yvkl4 {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card2bgdark__0vB9u {
  background: #1c3238;
}

#ToggleButton_card3bglight__Kqqmv {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card3bgdark__siCXv {
  background: #3a2434;
}

#ToggleButton_card4bglight__yPfuZ {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#ToggleButton_card4bgdark__KQ3Jn {
  background: #2f264f;
}

#ToggleButton_card1bgdark__dKi5L a,
#ToggleButton_card1bgdark__dKi5L p,
#ToggleButton_card2bgdark__0vB9u a,
#ToggleButton_card2bgdark__0vB9u p,
#ToggleButton_card3bgdark__siCXv a,
#ToggleButton_card3bgdark__siCXv p,
#ToggleButton_card4bgdark__KQ3Jn a,
#ToggleButton_card4bgdark__KQ3Jn p {
  color: #fff;
}

/* 
Action button theme
*/
.ToggleButton_actionbtnlight__74r4t {
  color: rgba(70, 71, 91, 0.8705882353);
}

.ToggleButton_actionbtndark__n\\+blE {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.ToggleButton_profiledropdownlight__i75Et {
  background-color: #fff;
}

.ToggleButton_profiledropdowndark__ydRyq {
  background-color: #151521;
}

.ToggleButton_settingsection__qgzvg #ToggleButton_addform__P2xOP.ToggleButton_formthemedark__CPoir .ToggleButton_savebtn__TXAnP {
  background-color: #3b82f6;
  color: #fff;
}

#ToggleButton_addform__P2xOP.ToggleButton_formthemedark__CPoir .ToggleButton_savebtn__TXAnP {
  background-color: #3b82f6;
  color: #fff;
}

.ToggleButton_profile_conatiner__mcUet {
  border-radius: 5px !important;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_ag-theme-alpine__6B\\+er .ToggleButton_ag-row__oz\\+e\\+ {
  background: #000 !important;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_formbtn__PHUbN {
  background-color: #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_formbtn__PHUbN:hover {
  background-color: #2563eb;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_resetbtn__V-tkS {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_resetbtn__V-tkS:hover {
  background-color: #3b82f6;
}

.ToggleButton_headingdark__7Kdz4 span {
  background-color: #132337;
}

.ToggleButton_resetbtn__V-tkS {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.ToggleButton_resetbtn__V-tkS:hover,
.ToggleButton_resetbtn__V-tkS:active,
.ToggleButton_resetbtn__V-tkS:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.ToggleButton_addBtn__SvaL8 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.ToggleButton_addDltBtn__iPF6p {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.ToggleButton_addbtnlight__hhs0R {
  background-color: #38A169;
}

.ToggleButton_addbtndark__MRXDH {
  background-color: #3b82f6;
}

.ToggleButton_addbtndark__MRXDH:hover {
  background-color: #2563eb;
}

.ToggleButton_formthemedark__CPoir label {
  color: #92afd3;
}

.ToggleButton_addBtn__SvaL8 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.ToggleButton_addBtn__SvaL8:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.ToggleButton_cust_addBtn__Gm3LP.ToggleButton_addBtn__SvaL8 svg {
  top: 2px;
}

.ToggleButton_deleteBtn__T5P7S {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ToggleButton_deleteBtn__T5P7S {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ToggleButton_deleteBtn__T5P7S:active,
.ToggleButton_deleteBtn__T5P7S:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.ToggleButton_deleteBtn__T5P7S svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.ToggleButton_deleteBtn__T5P7S:hover,
.ToggleButton_deleteBtn__T5P7S:active,
.ToggleButton_deleteBtn__T5P7S:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.ToggleButton_confirmBtn__NbQBi {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.ToggleButton_confirmBtn__NbQBi:hover,
.ToggleButton_confirmBtn__NbQBi:active,
.ToggleButton_confirmBtn__NbQBi:focus {
  background-color: #0f1824 !important;
}

.ToggleButton_confirmBtn__NbQBi svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.ToggleButton_delPopContainer__bvk45 .ToggleButton_modal-body__YPdm2 {
  padding: 35px;
  text-align: center;
}

.ToggleButton_delPopContainer__bvk45 .ToggleButton_delet_icon__xnDDd {
  margin-bottom: 11px;
}

.ToggleButton_delPopContainer__bvk45 p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.ToggleButton_arrowback__e-TLr svg {
  fill: #000;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_arrowback__e-TLr {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_arrowback__e-TLr svg {
  fill: #3b82f6;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_drpdwn_btn__3ckIW {
  background-color: #132337;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_empname__-nZNB {
  color: #92afd3 !important;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_navitemli__EcpRU a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_tabnavli__WFVt7 a.ToggleButton_settingsgeneral__Ht4wT,
.ToggleButton_bodythemedark__mk1cl .ToggleButton_tabnavli__WFVt7 a.ToggleButton_settingslinks__VyZug:hover {
  background-color: #3b82f6;
  color: #fff;
}

.ToggleButton_bodythemedark__mk1cl .ToggleButton_tabnavli__WFVt7 a.ToggleButton_settingslinks__VyZug {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc {
  background-color: #1c2e45;
  color: #fff;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc ul li a,
.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc .ToggleButton_dropdown_item__xy1l0,
.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc .ToggleButton_dropdown_item__xy1l0 h5 {
  color: #fff;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc ul li a:hover,
.ToggleButton_headerthemedark__6P1qs .ToggleButton_dropdown_menu_contain__tjeDc .ToggleButton_dropdown_item__xy1l0:hover {
  background-color: #132337;
  color: #fff;
}

.ToggleButton_dropdown_item__xy1l0:active {
  background-color: #F5F6FA;
}

.ToggleButton_profile_arrrow_dwn__GQMnz {
  stroke: #132337;
}

.ToggleButton_headerthemedark__6P1qs .ToggleButton_profile_arrrow_dwn__GQMnz {
  stroke: #fff;
}

.ToggleButton_dateinputbox1__\\+Vmha input,
.ToggleButton_dateinputbox1__\\+Vmha span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.ToggleButton_delPopContainer__bvk45 .ToggleButton_modal-content__-PNn3 {
  border-radius: 10px;
  min-width: 399px;
}

.ToggleButton_larg_model__qhjx4 .ToggleButton_modal-dialog__HyBM\\+ {
  max-width: 100% !important;
}

.ToggleButton_larg_model__qhjx4 .ToggleButton_modal-content__-PNn3 {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.ToggleButton_larg_model__qhjx4 .ToggleButton_modal-header__Oyr3X {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .ToggleButton_btn-primary__vmKrG:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.ToggleButton_form-select__NRReS {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .ToggleButton_CustomTable_tableheadlight__HuHZw__c2f3l th:first-child,
thead .ToggleButton_CustomTable_tableheaddark__nwqb4__6IgPr th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .ToggleButton_tableheadlight__HMlEb th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .ToggleButton_dashboard__6uIAT {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .ToggleButton_cont2__y79\\+w {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .ToggleButton_sectionright__jSHE2 {
    float: unset !important;
  }
  .ToggleButton_dashboard__6uIAT {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .ToggleButton_cont2__y79\\+w {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .ToggleButton_bodythemelight__xbVdb,
.ToggleButton_bodythemedark__mk1cl {
    padding-top: 110px;
  }
  .ToggleButton_delPopContainer__bvk45 .ToggleButton_modal-content__-PNn3 {
    min-width: 100%;
  }
  .ToggleButton_delPopContainer__bvk45 .ToggleButton_modal-body__YPdm2 {
    padding: 15px;
  }
  .ToggleButton_larg_model__qhjx4 .ToggleButton_modal-content__-PNn3 {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .ToggleButton_exer_modal_contain__lh\\+AY .ToggleButton_modal-dialog__HyBM\\+ {
    max-width: 1055px;
  }
  .ToggleButton_delPopContainer__bvk45 .ToggleButton_modal-dialog__HyBM\\+ {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.ToggleButton_active_show_outer__ErM9W h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .ToggleButton_active_show_outer__ErM9W h2 {
    margin-top: 15px;
  }
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH {
  width: 100%;
  display: block;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_img__aremA {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_img__aremA {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_img__aremA img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG {
  width: 100%;
  display: block;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG svg {
  flex-shrink: 0;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG .ToggleButton_act_box_bdg__0AlBJ {
  width: 100%;
  margin-bottom: 12px;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG .ToggleButton_act_box_bdg__0AlBJ span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG .ToggleButton_act_box_bdg__0AlBJ .ToggleButton_sold__Y1Qno {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.ToggleButton_active_show_outer__ErM9W .ToggleButton_active_show_inner__SdlzH .ToggleButton_act_box_cnt__kRGUG p .ToggleButton_timezone_code_pill__kFeQl {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#ToggleButton_attent_details_row1__WiWzh {
  margin-bottom: 0 !important;
}

.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_l__4m-zB img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB {
  flex: 1 1;
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row__uULlG {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row__uULlG {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row__uULlG .ToggleButton_attent_details_row_box__CZxd1 {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row__uULlG .ToggleButton_attent_details_row_box__CZxd1 {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row__uULlG .ToggleButton_attent_details_row_box__CZxd1 {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row__uULlG .ToggleButton_attent_details_row_box__CZxd1 p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row__uULlG .ToggleButton_attent_details_row_box__CZxd1 h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row_last__kbTf\\+ {
  margin-bottom: 0px !important;
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row_last__kbTf\\+.ToggleButton_interesting_fact__wlJOA {
  padding-top: 30px;
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row_last__kbTf\\+.ToggleButton_interesting_fact__wlJOA .ToggleButton_attent_details_row_box__CZxd1 {
  width: 100%;
}
.ToggleButton_attent_details__WXmJZ .ToggleButton_attent_details_inner__wp9cN .ToggleButton_attent_details_inner_r__uRoRB .ToggleButton_attent_details_row_last__kbTf\\+.ToggleButton_interesting_fact__wlJOA .ToggleButton_attent_details_row_box__CZxd1 h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.ToggleButton_showbox_sec__LBqee {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .ToggleButton_showbox_sec__LBqee {
    justify-content: center;
  }
}

.ToggleButton_show_box_main__1UujS {
  margin: 10px 0px;
}
.ToggleButton_show_box_main__1UujS .ToggleButton_show_box__E3Z5a {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .ToggleButton_show_box_main__1UujS .ToggleButton_show_box__E3Z5a {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .ToggleButton_show_box_main__1UujS .ToggleButton_show_box__E3Z5a {
    min-height: 500px;
    width: 200px !important;
  }
}
.ToggleButton_show_box_main__1UujS .ToggleButton_show_box__E3Z5a img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .ToggleButton_show_box_main__1UujS .ToggleButton_show_box__E3Z5a img {
    max-height: 300px !important;
  }
}
.ToggleButton_show_box_main__1UujS .ToggleButton_show_box__E3Z5a:last-child {
  margin-right: 0px !important;
}
.ToggleButton_show_box_main__1UujS .ToggleButton_no_show_box__GR\\+Qu {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .ToggleButton_show_box_main__1UujS .ToggleButton_no_show_box__GR\\+Qu {
    width: 250px !important;
  }
}
.ToggleButton_show_box_main__1UujS .ToggleButton_no_show_box__GR\\+Qu img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .ToggleButton_show_box_main__1UujS .ToggleButton_no_show_box__GR\\+Qu img {
    max-height: 350px !important;
  }
}
.ToggleButton_show_box_main__1UujS .ToggleButton_no_show_box__GR\\+Qu h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .ToggleButton_show_box_main__1UujS .ToggleButton_no_show_box__GR\\+Qu h6 {
    font-size: 20px;
  }
}

.ToggleButton_attent_flex__PC\\+zc {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.ToggleButton_attent_flex__PC\\+zc h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

.ToggleButton_activebtn__Q2Kd4 {
  border: none;
  color: #fff;
  background-color: #50cd89;
  width: 70px;
  border-radius: 34px;
  line-height: 25px;
}

.ToggleButton_inactivebtn__NGuUK {
  border: none;
  color: #dee2e6;
  background-color: #737a92;
  width: 70px;
  border-radius: 34px;
  line-height: 25px;
}

/* Basic Rules */
.ToggleButton_switch__6Kmug input {
  display: none;
}

.ToggleButton_switch__6Kmug {
  display: inline-block;
  width: 50px;
  height: 20px;
  margin: 2px;
  transform: translateY(50%);
  position: relative;
}

/* Style Wired */
.ToggleButton_slider__nic9a {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 30px;
  box-shadow: 0 0 0 1px #777, 0 0 1px #777;
  cursor: pointer;
  border: 4px solid transparent;
  overflow: hidden;
  transition: 0.2s;
  height: 20px;
}

.ToggleButton_slider__nic9a:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: #777;
  border-radius: 30px;
  transform: translateX(-30px);
  transition: 0.2s;
}

input:checked + .ToggleButton_slider__nic9a:before {
  transform: translateX(30px);
  background: limeGreen;
}

input:checked + .ToggleButton_slider__nic9a {
  box-shadow: 0 0 0 2px limeGreen, 0 0 2px limeGreen;
}

/* Style Flat */
.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE .ToggleButton_slider__nic9a {
  box-shadow: none;
}

.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE .ToggleButton_slider__nic9a:before {
  background: #FFF;
}

.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE input:checked + .ToggleButton_slider__nic9a:before {
  background: white;
}

.ToggleButton_switch__6Kmug.ToggleButton_flat__OIQaE input:checked + .ToggleButton_slider__nic9a {
  background: limeGreen;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/ToggleButton/ToggleButton.module.scss"],"names":[],"mappings":"AAAA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ACvEF;;AD0EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACvEF;;AD0EA;;;EAGE,yBApEoB;ACHtB;;AD0EA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACvEF;;AD0EA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ACrEF;;AD2EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACxEF;;AD6EA;EACE,2BAAA;AC1EF;;AD6EA;EACE,yBAAA;EACA,YAAA;AC1EF;;AD8EA;EACE,YAAA;AC3EF;;AD8EA;EACE,sBA9GY;ACmCd;;AD8EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AC3EF;;AD8EA;EACE,yBArIgB;EAsIhB,iBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,sBAtIY;AC2Dd;;AD8EA;EACE,yBArJgB;AC0ElB;;AD8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AC3EF;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBA1KgB;AC+FlB;;AD8EA;;CAAA;AAGA;EACE,yBAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;;EAEE,sBAAA;AC3EF;;AD8EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AC4HpB;;AD8EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,sBAAA;EACA,oCAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;EACE,0BAAA;AC3EF;;AD8EA;EACE,uBAAA;AC3EF;;AD8EA;;EAEE,qBAAA;AC3EF;;AD8EA;EACE,yBArOsB;EAsOtB,WA7NY;ACkJd;;AD8EA;;CAAA;AAGA;EACE,cAjOe;ACsJjB;;AD8EA;EACE,cArOe;AC0JjB;;AD8EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AC3EF;;AD8EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AC3EF;;AD8EA;EACE,cAvPe;AC4KjB;;AD8EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AC3EF;;AD8EA;EACE,WAtQY;AC2Ld;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;;EAEE,0BAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,kBAAA;AC3EF;;AD8EA;EACE,oCAAA;EACA,gCAAA;AC3EF;;AD8EA;EACE,yBAzRkB;EA0RlB,WAlSY;ACuNd;;AD8EA;EACE,yBAAA;AC3EF;;AD8EA;EACE,iBAAA;AC3EF;;AD8EA;;EAEE,+BAAA;EACA,iBAAA;AC3EF;;AD8EA;EACE,sBApTY;ACyOd;AD6EE;EACE,sBAvTU;EAwTV,YAAA;AC3EJ;AD6EE;EACA,iBAAA;AC3EF;;ADgFA;EACE,0CAAA;EACA,cA/Te;ACkPjB;AD+EE;EACE,yCAAA;EACA,eAAA;AC7EJ;;ADiFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;EACE,yBAAA;EACA,0BAAA;AC9EF;;ADiFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AC9EF;;ADiFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AC9EF;ADgFE;EACE,cAnWa;ACqRjB;;ADmFA;;CAAA;AAGA;EACE,yBAlXgB;ACkSlB;;ADmFA;EACE,yBAAA;EACA,yBAAA;AChFF;;ADmFA;EACE,yBAlYoB;EAmYpB,yBAAA;AChFF;;ADmFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AChFF;;ADmFA;;CAAA;AAGA;EACE,sBAtYY;ACsTd;;ADmFA;EACE,yBAlYkB;ACkTpB;;ADoFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ACkUd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA5ZY;AC2Ud;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBAraY;ACoVd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;EACE,gGAAA;EACA,sBA9aY;AC6Vd;;ADoFA;EACE,mBAAA;ACjFF;;ADoFA;;;;;;;;EAQE,WA7bY;AC4Wd;;ADoFA;;CAAA;AAGA;EACE,qCAAA;ACjFF;;ADoFA;EACE,cArce;ACoXjB;;ADqFA;;CAAA;AAGA;EACE,sBAAA;AClFF;;ADqFA;EACE,yBAAA;AClFF;;ADqFA;EACE,yBAzekB;EA0elB,WAzdY;ACuYd;;ADqFA;EACE,yBA9ekB;EA+elB,WA9dY;AC4Yd;;ADqFA;EACE,6BAAA;AClFF;;ADqFA;EACE,2BAAA;AClFF;;ADqFA;EACE,yBA3fkB;ACyapB;;ADqFA;EACE,yBA9fwB;AC4a1B;;ADqFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;AClFF;;ADqFA;EACE,yBAzgBkB;ACubpB;;ADsFA;EACE,yBAxgBgB;ACqblB;;ADsFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ACnFF;;ADsFA;;;EAGE,oCAAA;EACA,sBAAA;ACnFF;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ACwfhB;;ADsFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ACkgBhB;;ADsFA;EACE,yBAjkBY;AC8ed;;ADsFA;EACE,yBA3jBkB;ACwepB;;ADsFA;EACE,yBA9jBwB;AC2e1B;;ADsFA;EACE,cApkBiB;ACifnB;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpFF;;ADuFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ACpFF;;ADuFA;EACE,QAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ACpFF;;ADuFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ACpFF;;ADuFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADuFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ACpFF;;ADuFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ACpFF;;ADuFA;;;EAGE,oCAAA;ACpFF;;ADuFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACpFF;;ADyFA;EACE,aAAA;EACA,kBAAA;ACtFF;;ADyFA;EACE,mBAAA;ACtFF;;ADyFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACtFF;;ADyFA;EACE,UAAA;ACtFF;;ADyFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AC0lBpB;;ADyFA;EACE,aAprBkB;AC8lBpB;;ADyFA;EACE,yBAhrBgB;AC0lBlB;;ADyFA;EACE,yBAAA;ACtFF;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;ACylBd;;ADyFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;AC+lBd;;ADyFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ACqmBd;;ADyFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AC0mBd;;ADyFA;;;EAGE,WAtsBY;ACgnBd;;ADyFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ACsnBd;;ADyFA;EACE,yBA9vBO;ACwqBT;;ADyFA;EACE,eA/tBgB;ACyoBlB;;ADyFA;EACE,YAxtBY;ACkoBd;;ADyFA;;EAEE,sBAAA;ACtFF;;ADyFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;AC1FF;;AD6FA;EACE,0BAAA;AC1FF;;AD6FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;AC1FF;;AD6FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;AC1FF;;AD6FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AC1FF;;AD6FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;AC1FF;;AD6FA;;EAEE,0BAAA;EACA,aAAA;AC1FF;;AD6FA;EACE,kBAAA;EACA,kBAAA;AC1FF;;AD6FA;EACE;IACE,gBAAA;EC1FF;AACF;AD6FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;EC3FF;ED8FA;IACE,uBAAA;IACA,+BAAA;EC5FF;AACF;AD+FA;EACE;;IAAA;AC3FF;ADgGA;EACE;IACE,uBAAA;EC9FF;EDiGA;IACE,6BAAA;EC/FF;AACF;ADkGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;EChGF;EDmGA;;IAEE,kBAAA;ECjGF;EDoGA;IACE,eAAA;EClGF;EDqGA;IACE,aAAA;ECnGF;EDsGA;IACE,8BAAA;IACA,aAAA;ECpGF;AACF;ADuGA;EACE;IACE,iBAAA;ECrGF;EDwGA;IACE,gBAAA;ECtGF;EDyGA;;KAAA;ACrGF;AD0GA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1GJ;AD2GI;EAPF;IAQI,gBAAA;ECxGJ;AACF;AD2GE;EACE,WAAA;EACA,cAAA;ACzGJ;AD2GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ACzGN;AD0GM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;ECvGN;AACF;ADwGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ACtGR;AD0GI;EACE,WAAA;EACA,cAAA;ACxGN;ADyGA;EACE,cAAA;ACvGF;ADyGM;EACE,WAAA;EACA,mBAAA;ACvGR;ADyGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ACvGV;AD0GQ;EACE,kFAAA;ACxGV;AD6GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AC3GR;AD8GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC5GR;AD8GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AC5GV;AD+GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AC7GV;;ADoHA,mBAAA;AACA;EACI,2BAAA;ACjHJ;;ADoHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ACjHJ;ADmHI;EATF;IAUI,yBAAA;EChHJ;AACF;ADkHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;EC/GJ;AACF;ADkHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AChHR;ADoHI;EACE,SAAA;AClHN;ADoHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AClHR;ADoHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;ECjHR;AACF;ADmHQ;EACE,SAAA;EACA,UAAA;ACjHV;ADmHU;EAJF;IAKI,gCAAA;IACA,sBAAA;EChHV;AACF;ADkHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;EC/GV;AACF;ADiHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC/GZ;ADkHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AChHZ;ADqHM;EACE,6BAAA;ACnHR;ADoHQ;EACE,iBAAA;AClHV;ADmHU;EACE,WAAA;ACjHZ;ADkHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AChHd;;ADyHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ACtHJ;ADuHI;EANH;IAOK,uBAAA;ECpHJ;AACF;;ADsHA;EACE,gBAAA;ACnHF;ADqHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ACnHJ;ADqHI;EARF;IASI,kBAAA;EClHJ;AACF;ADmHI;EAXF;IAYI,iBAAA;IACA,uBAAA;EChHJ;AACF;ADkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AChHN;ADkHM;EALF;IAMI,4BAAA;EC/GN;AACF;ADkHI;EACE,4BAAA;AChHN;ADoHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AClHJ;ADoHI;EALF;IAMI,uBAAA;ECjHJ;AACF;ADmHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACjHN;ADmHM;EALF;IAMI,4BAAA;EChHN;AACF;ADkHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AChHN;ADiHM;EARF;IASI,eAAA;EC9GN;AACF;;ADqHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;AClHF;ADoHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AClHJ;;AA1lCA;EACG,YAAA;EACA,WDoDW;ECnDX,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AA6lCH;;AAzlCA;EACE,YAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AA4lCF;;AArlCA,gBAAA;AACA;EACE,aAAA;AAwlCF;;AAtlCA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;AAylCF;;AAvlCA,gBAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACC,gBAAA;EACA,YAAA;AA0lCH;;AAxlCA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AA2lCF;;AAxlCA;EACE,2BAAA;EACA,qBAAA;AA2lCF;;AAzlCA;EACE,kDAAA;AA4lCF;;AAzlCA,eAAA;AACA;EACA,gBAAA;AA4lCA;;AA1lCA;EACA,gBAAA;AA6lCA;;AA3lCA;EACA,iBAAA;AA8lCA;;AA5lCA;EACA,qBAAA;AA+lCA","sourcesContent":["/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n.activebtn{\n   border: none;\n   color: $white-color;\n   background-color: #50cd89;\n   width: 70px;\n   border-radius: 34px;\n   line-height: 25px;\n    \n  //  box-shadow: 0 1px 2px #babfc7;\n}\n.inactivebtn{\n  border: none;\n  color: #dee2e6;\n  background-color: #737a92;\n  width: 70px;\n  border-radius: 34px;\n  line-height: 25px;\n   \n  // box-shadow: 0 1px 2px #babfc7;\n}\n\n\n\n/* Basic Rules */\n.switch input { \n  display:none;\n}\n.switch {\n  display:inline-block;\n  width:50px;\n  height:20px;\n  margin:2px;\n  transform:translateY(50%);\n  position:relative;\n}\n/* Style Wired */\n.slider {\n  position:absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n  border-radius:30px;\n  box-shadow:0 0 0 1px #777, 0 0 1px #777;\n  cursor:pointer;\n  border:4px solid transparent;\n  overflow:hidden;\n   transition:.2s;\n   height: 20px;\n}\n.slider:before {\n  position:absolute;\n  content:\"\";\n  width:100%;\n  height:100%;\n  background:#777;\n  border-radius:30px;\n  transform:translateX(-30px);\n  transition:.2s;\n}\n\ninput:checked + .slider:before {\n  transform:translateX(30px);\n  background:limeGreen;\n}\ninput:checked + .slider {\n  box-shadow:0 0 0 2px limeGreen,0 0 2px limeGreen;\n}\n\n/* Style Flat */\n.switch.flat .slider {\nbox-shadow:none;\n}\n.switch.flat .slider:before {\nbackground:#FFF;\n}\n.switch.flat input:checked + .slider:before {\nbackground:white;\n}\n.switch.flat input:checked + .slider {\nbackground:limeGreen;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `ToggleButton_dashboard__6uIAT`,
	"dashboardContain": `ToggleButton_dashboardContain__G3Iom`,
	"bodythemedark": `ToggleButton_bodythemedark__mk1cl`,
	"cont2": `ToggleButton_cont2__y79+w`,
	"top_header": `ToggleButton_top_header__Cqcd3`,
	"top_header_inner": `ToggleButton_top_header_inner__Uy0t5`,
	"subLink": `ToggleButton_subLink__qrmnO`,
	"cst_vendr": `ToggleButton_cst_vendr__TITQX`,
	"form-control": `ToggleButton_form-control__klRMx`,
	"footer": `ToggleButton_footer__k+jkH`,
	"bodythemelight": `ToggleButton_bodythemelight__xbVdb`,
	"bodythemeNew": `ToggleButton_bodythemeNew__Ui6IB`,
	"headerthemelight": `ToggleButton_headerthemelight__KBxNK`,
	"headerthemedark": `ToggleButton_headerthemedark__6P1qs`,
	"menuthemelight": `ToggleButton_menuthemelight__Um682`,
	"menuthemedark": `ToggleButton_menuthemedark__VX9a7`,
	"menulinklight": `ToggleButton_menulinklight__fo-41`,
	"menulinkdarkSelected": `ToggleButton_menulinkdarkSelected__v5Q2p`,
	"menulinklightSelected": `ToggleButton_menulinklightSelected__p-O0O`,
	"menulinkdark": `ToggleButton_menulinkdark__H9koF`,
	"sub_arrow": `ToggleButton_sub_arrow__3tNzG`,
	"headinglight": `ToggleButton_headinglight__46yE4`,
	"headingdark": `ToggleButton_headingdark__7Kdz4`,
	"searchboxlight": `ToggleButton_searchboxlight__IgyaT`,
	"searchboxdark": `ToggleButton_searchboxdark__s-55U`,
	"tableheadlight": `ToggleButton_tableheadlight__HMlEb`,
	"tableheaddark": `ToggleButton_tableheaddark__CqMs1`,
	"table": `ToggleButton_table__gUUsS`,
	"table-borderless": `ToggleButton_table-borderless__eH6QQ`,
	"left-section": `ToggleButton_left-section__meX0e`,
	"tablebodylight": `ToggleButton_tablebodylight__CqriS`,
	"tablebodydark": `ToggleButton_tablebodydark__9ZXJj`,
	"paginationlight": `ToggleButton_paginationlight__BaJSK`,
	"paginationdark": `ToggleButton_paginationdark__fwOiV`,
	"formthemelight": `ToggleButton_formthemelight__WUeV2`,
	"formthemedark": `ToggleButton_formthemedark__CPoir`,
	"viewformlight": `ToggleButton_viewformlight__kVJ4n`,
	"permissionboxlight": `ToggleButton_permissionboxlight__gxJYP`,
	"permissionboxdark": `ToggleButton_permissionboxdark__HAgO2`,
	"errormsgclr": `ToggleButton_errormsgclr__Lb-s-`,
	"graphclrlight": `ToggleButton_graphclrlight__CuUx3`,
	"graphclrdark": `ToggleButton_graphclrdark__pHaGO`,
	"card1bglight": `ToggleButton_card1bglight__cN6YD`,
	"card1bgdark": `ToggleButton_card1bgdark__dKi5L`,
	"card2bglight": `ToggleButton_card2bglight__Yvkl4`,
	"card2bgdark": `ToggleButton_card2bgdark__0vB9u`,
	"card3bglight": `ToggleButton_card3bglight__Kqqmv`,
	"card3bgdark": `ToggleButton_card3bgdark__siCXv`,
	"card4bglight": `ToggleButton_card4bglight__yPfuZ`,
	"card4bgdark": `ToggleButton_card4bgdark__KQ3Jn`,
	"actionbtnlight": `ToggleButton_actionbtnlight__74r4t`,
	"actionbtndark": `ToggleButton_actionbtndark__n+blE`,
	"profiledropdownlight": `ToggleButton_profiledropdownlight__i75Et`,
	"profiledropdowndark": `ToggleButton_profiledropdowndark__ydRyq`,
	"settingsection": `ToggleButton_settingsection__qgzvg`,
	"addform": `ToggleButton_addform__P2xOP`,
	"savebtn": `ToggleButton_savebtn__TXAnP`,
	"profile_conatiner": `ToggleButton_profile_conatiner__mcUet`,
	"ag-theme-alpine": `ToggleButton_ag-theme-alpine__6B+er`,
	"ag-row": `ToggleButton_ag-row__oz+e+`,
	"formbtn": `ToggleButton_formbtn__PHUbN`,
	"resetbtn": `ToggleButton_resetbtn__V-tkS`,
	"addBtn": `ToggleButton_addBtn__SvaL8`,
	"addDltBtn": `ToggleButton_addDltBtn__iPF6p`,
	"addbtnlight": `ToggleButton_addbtnlight__hhs0R`,
	"addbtndark": `ToggleButton_addbtndark__MRXDH`,
	"cust_addBtn": `ToggleButton_cust_addBtn__Gm3LP`,
	"deleteBtn": `ToggleButton_deleteBtn__T5P7S`,
	"confirmBtn": `ToggleButton_confirmBtn__NbQBi`,
	"delPopContainer": `ToggleButton_delPopContainer__bvk45`,
	"modal-body": `ToggleButton_modal-body__YPdm2`,
	"delet_icon": `ToggleButton_delet_icon__xnDDd`,
	"arrowback": `ToggleButton_arrowback__e-TLr`,
	"drpdwn_btn": `ToggleButton_drpdwn_btn__3ckIW`,
	"empname": `ToggleButton_empname__-nZNB`,
	"navitemli": `ToggleButton_navitemli__EcpRU`,
	"tabnavli": `ToggleButton_tabnavli__WFVt7`,
	"settingsgeneral": `ToggleButton_settingsgeneral__Ht4wT`,
	"settingslinks": `ToggleButton_settingslinks__VyZug`,
	"dropdown_menu_contain": `ToggleButton_dropdown_menu_contain__tjeDc`,
	"dropdown_item": `ToggleButton_dropdown_item__xy1l0`,
	"profile_arrrow_dwn": `ToggleButton_profile_arrrow_dwn__GQMnz`,
	"dateinputbox1": `ToggleButton_dateinputbox1__+Vmha`,
	"modal-content": `ToggleButton_modal-content__-PNn3`,
	"larg_model": `ToggleButton_larg_model__qhjx4`,
	"modal-dialog": `ToggleButton_modal-dialog__HyBM+`,
	"modal-header": `ToggleButton_modal-header__Oyr3X`,
	"btn-primary": `ToggleButton_btn-primary__vmKrG`,
	"form-select": `ToggleButton_form-select__NRReS`,
	"CustomTable_tableheadlight__HuHZw": `ToggleButton_CustomTable_tableheadlight__HuHZw__c2f3l`,
	"CustomTable_tableheaddark__nwqb4": `ToggleButton_CustomTable_tableheaddark__nwqb4__6IgPr`,
	"sectionright": `ToggleButton_sectionright__jSHE2`,
	"exer_modal_contain": `ToggleButton_exer_modal_contain__lh+AY`,
	"active_show_outer": `ToggleButton_active_show_outer__ErM9W`,
	"active_show_inner": `ToggleButton_active_show_inner__SdlzH`,
	"act_box_img": `ToggleButton_act_box_img__aremA`,
	"act_box_cnt": `ToggleButton_act_box_cnt__kRGUG`,
	"act_box_bdg": `ToggleButton_act_box_bdg__0AlBJ`,
	"sold": `ToggleButton_sold__Y1Qno`,
	"timezone_code_pill": `ToggleButton_timezone_code_pill__kFeQl`,
	"attent_details_row1": `ToggleButton_attent_details_row1__WiWzh`,
	"attent_details": `ToggleButton_attent_details__WXmJZ`,
	"attent_details_inner": `ToggleButton_attent_details_inner__wp9cN`,
	"attent_details_inner_l": `ToggleButton_attent_details_inner_l__4m-zB`,
	"attent_details_inner_r": `ToggleButton_attent_details_inner_r__uRoRB`,
	"attent_details_row": `ToggleButton_attent_details_row__uULlG`,
	"attent_details_row_box": `ToggleButton_attent_details_row_box__CZxd1`,
	"attent_details_row_last": `ToggleButton_attent_details_row_last__kbTf+`,
	"interesting_fact": `ToggleButton_interesting_fact__wlJOA`,
	"showbox_sec": `ToggleButton_showbox_sec__LBqee`,
	"show_box_main": `ToggleButton_show_box_main__1UujS`,
	"show_box": `ToggleButton_show_box__E3Z5a`,
	"no_show_box": `ToggleButton_no_show_box__GR+Qu`,
	"attent_flex": `ToggleButton_attent_flex__PC+zc`,
	"activebtn": `ToggleButton_activebtn__Q2Kd4`,
	"inactivebtn": `ToggleButton_inactivebtn__NGuUK`,
	"switch": `ToggleButton_switch__6Kmug`,
	"slider": `ToggleButton_slider__nic9a`,
	"flat": `ToggleButton_flat__OIQaE`
};
export default ___CSS_LOADER_EXPORT___;
